import React from 'react';

import PlaceholderTab from '~/components/Offers/Detail/OfferBuilder/shared/PlaceholderTab';

import { SURCHARGE_FIELDS } from './fields';

export default function SurchargesTab() {
  return <PlaceholderTab configuredFieldCount={SURCHARGE_FIELDS.length} title="Surcharges" />;
}
